import { styled } from '@mui/material/styles';
import { Box, alpha } from '@mui/material';

 const StyledBox = styled(Box)(({ theme }) => ({
  position: 'relative',
  '& .HIWSBackground': {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    zIndex: 0,
  },
  '& .HIWSBGOverlay': {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    zIndex: 1,
    background: `${alpha(theme.palette.background.primary, 0.87)}`,
  },
  '& .HIWSContantContainer': {
    position: 'relative',
    zIndex: 2,
    maxWidth: theme.spacing(94),
    margin: 'auto',
    padding: theme.spacing(16, 0, 16, 0),
    [theme.breakpoints.down('xl')]: {
      padding: theme.spacing(14, 0, 14, 0),
    },
     [theme.breakpoints.down('lg')]: {
      padding: theme.spacing(8, 0, 8, 0),
    },
  },

   '& .HIWSTimeLine': {
    padding: 0,
    margin: theme.spacing(4, 0 ,0),
  },
  '& .HIWSTimeIItem': {
    minHeight: theme.spacing(3),
    '&:before': {
      flex: 0,
      padding: 0,
    },
     '&:last-child': {
       '& .HIWSTimelineContent': {
           padding: theme.spacing(0, 0, 0, 6),
       }
     }
  },
  '& .HIWSTimelineContent': {
      padding: theme.spacing(0, 0, 6, 6),
    },
  '& .HIWSTimelineConnector': {
    backgroundColor: theme.palette.divider[1],
    width: theme.typography.pxToRem(3),
    border: `1px solid ${theme.palette.divider[1]}`,
    '&.HIWSEmptyConnector': {
      marginLeft: theme.typography.pxToRem(8),
      [theme.breakpoints.down('md')]: {
        marginLeft: theme.typography.pxToRem(4),
      },
    },
  },
  '& .HIWSTimelineDot': {
    borderWidth: theme.typography.pxToRem(3),
    padding: theme.typography.pxToRem(5),
    backgroundColor: theme.palette.common.white,
    [theme.breakpoints.down('md')]: {
      borderWidth: theme.typography.pxToRem(2),
      padding: theme.typography.pxToRem(2),
    },
  },

}));
export default StyledBox;